export type ITimeOptions = "minutes" | "hours" | "days";

export interface TimerOptions {
  id: ITimeOptions;
  name: string;
}

export const TIME_OPTIONS: TimerOptions[] = [
  {
    id: "minutes",
    name: "Minute(s)",
  },
  {
    id: "hours",
    name: "Hour(s)",
  },
  {
    id: "days",
    name: "Day(s)",
  },
];

export interface ConditionTimeOption {
  id: string;
  name: string;
}

export const CONDITION_TIME_OPTIONS: ConditionTimeOption[] = [
  {
    id: "1",
    name: "Any day",
  },
  {
    id: "2",
    name: "When the day",
  },
  {
    id: "3",
    name: "When the week day",
  },
  {
    id: "4",
    name: "When the weekend",
  },
  {
    id: "5",
    name: "Specific days",
  },
];

export interface DayWeekOption {
  id: string;
  name: string;
}

export const DAY_WEEK_OPTIONS = [
  {
    id: "0",
    name: "Sunday",
  },
  {
    id: "1",
    name: "Monday",
  },
  {
    id: "2",
    name: "Tuesday",
  },
  {
    id: "3",
    name: "Wednesday",
  },
  {
    id: "4",
    name: "Thursday",
  },
  {
    id: "5",
    name: "Friday",
  },
  {
    id: "6",
    name: "Saturday",
  },
];

export const HOUR_OPTIONS = Array(24)
  .fill(0)
  .map((e, i) => {
    const period = i + 1 < 13 ? "am" : "pm";
    const hour = i + 1 < 13 ? i + 1 : i - 11;

    return {
      id: `${i + 1}`,
      name: `${hour}:00 ${period}`,
    };
  });
